import React from 'react'
import {
  List, Datagrid, TextField, ReferenceField, DateField, Filter, ReferenceInput, SelectInput,
  FunctionField
} from 'admin-on-rest'
import MonetaryField from '../components/monetaryField'

const DepositFilter = (props) => (
  <Filter {...props}>
    <ReferenceInput label='Empresa' source='_organization' reference='organization' perPage={400} allowEmpty>
      <SelectInput optionText='name' />
    </ReferenceInput>
  </Filter>
)

export const DepositList = (props) => (
  <List {...props} title='Depósitos' filters={<DepositFilter />}>
    <Datagrid>
      <DateField label='Data' source='createdAt' locales='pt-br' showTime />
      <ReferenceField label='Empresa' source='_organization' reference='organization'>
        <TextField label='Nome' source='name' />
      </ReferenceField>
      <ReferenceField label='Usuário' source='_user' reference='user'>
        <FunctionField label='Nome' source='firstName' render={record => `${record.firstName} ${record.lastName}`} />
      </ReferenceField>
      <MonetaryField label='Valor' source='value' />
    </Datagrid>
  </List>
)



// WEBPACK FOOTER //
// ./src/collections/deposits.js